import { GameVars } from "../../GameVars";
import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";

export class LobbyGUI extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {

        super(scene);

        if (GameConstants.DEVELOPMENT) {
            
            const resetBtn = new Phaser.GameObjects.Graphics(this.scene);
            resetBtn.setPosition(60, 30);
            resetBtn.scaleX = GameVars.scaleX;
            resetBtn.fillStyle(0xffffff);
            resetBtn.fillRoundedRect(-50, -20, 100, 40, 5);
            resetBtn.setInteractive(new Phaser.Geom.Rectangle(-50, -20, 100, 40), Phaser.Geom.Rectangle.Contains);
            resetBtn.on("pointerdown", this.onClickReset, this);
            this.add(resetBtn);

            const resetText = new Phaser.GameObjects.Text(this.scene, 60, 30,  "RESET", {fontFamily: "Rubik-Regular", fontSize: "20px", color: "#563744", align: "center"});
            resetText.setOrigin(.5);
            resetText.scaleX = GameVars.scaleX;
            this.add(resetText);

            const unlockBtn = new Phaser.GameObjects.Graphics(this.scene);
            unlockBtn.setPosition(170, 30);
            unlockBtn.scaleX = GameVars.scaleX;
            unlockBtn.fillStyle(0xffffff);
            unlockBtn.fillRoundedRect(-50, -20, 100, 40, 5);
            unlockBtn.setInteractive(new Phaser.Geom.Rectangle(-50, -20, 100, 40), Phaser.Geom.Rectangle.Contains);
            unlockBtn.on("pointerdown", this.onClickUnlock, this);
            this.add(unlockBtn);

            const unlockText = new Phaser.GameObjects.Text(this.scene, 170, 30,  "UNLOCK\nALL", {fontFamily: "Rubik-Regular", fontSize: "16px", color: "#563744", align: "center"});
            unlockText.setOrigin(.5);
            unlockText.scaleX = GameVars.scaleX;
            this.add(unlockText);

            const levelsEditorBtn = new Phaser.GameObjects.Graphics(this.scene);
            levelsEditorBtn.setPosition(280, 30);
            levelsEditorBtn.scaleX = GameVars.scaleX;
            levelsEditorBtn.fillStyle(0xffffff);
            levelsEditorBtn.fillRoundedRect(-50, -20, 100, 40, 5);
            levelsEditorBtn.setInteractive(new Phaser.Geom.Rectangle(-50, -20, 100, 40), Phaser.Geom.Rectangle.Contains);
            levelsEditorBtn.on("pointerdown", this.onClickLevelsEditor, this);
            this.add(levelsEditorBtn);

            const levelsEditorText = new Phaser.GameObjects.Text(this.scene, 280, 30,  "LEVELS\nEDITOR", {fontFamily: "Rubik-Regular", fontSize: "16px", color: "#563744", align: "center"});
            levelsEditorText.setOrigin(.5);
            levelsEditorText.scaleX = GameVars.scaleX;
            this.add(levelsEditorText);
        }

        const musicBtn = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH - 3, 5, "texture_atlas_1", GameVars.gameData.soundtrackMuted ? "btn_music_idle_off" : "btn_music_idle");
        musicBtn.setInteractive();
        musicBtn.scaleX = GameVars.scaleX;
        musicBtn.setOrigin(1, 0);
        musicBtn.on("pointerdown", function () {
            musicBtn.setFrame(GameVars.gameData.soundtrackMuted ? "btn_music_pressed" : "btn_music_pressed_off");
            AudioManager.playSound("btn_click");
        }, this);
        musicBtn.on("pointerup", function () {
            AudioManager.toggleSoundtrackState();
            musicBtn.setFrame(GameVars.gameData.soundtrackMuted ? "btn_music_idle_off" : "btn_music_idle");
        }, this);
        musicBtn.on("pointerout", function () {
            musicBtn.setFrame(GameVars.gameData.soundtrackMuted ? "btn_music_idle_off" : "btn_music_idle");
        }, this);
        musicBtn.on("pointerover", function () {
            musicBtn.setFrame(GameVars.gameData.soundtrackMuted ? "btn_music_over" : "btn_music_over_off");
        }, this);
        this.add(musicBtn);

        const fxBtn = new Phaser.GameObjects.Image(this.scene, musicBtn.x - (musicBtn.width + 3) * GameVars.scaleX, 5, "texture_atlas_1", GameVars.gameData.soundMuted ? "btn_fx_idle_off" : "btn_fx_idle");
        fxBtn.setInteractive();
        fxBtn.scaleX = GameVars.scaleX;
        fxBtn.setOrigin(1, 0);
        fxBtn.on("pointerdown", function () {
            fxBtn.setFrame(GameVars.gameData.soundMuted ? "btn_fx_pressed" : "btn_fx_pressed_off");
        }, this);
        fxBtn.on("pointerup", function () {
            AudioManager.toggleSoundState();
            AudioManager.playSound("btn_click");
            fxBtn.setFrame(GameVars.gameData.soundMuted ? "btn_fx_idle_off" : "btn_fx_idle");
        }, this);
        fxBtn.on("pointerout", function () {
            fxBtn.setFrame(GameVars.gameData.soundMuted ? "btn_fx_idle_off" : "btn_fx_idle");
        }, this);
        fxBtn.on("pointerover", function () {
            fxBtn.setFrame(GameVars.gameData.soundMuted ? "btn_fx_over" : "btn_fx_over_off");
        }, this);
        this.add(fxBtn);
    }

    private onClickReset(): void {

        GameVars.levelCompleted = null;
        localStorage.clear();
        GameManager.initGameData();
        GameManager.enterLobbyScene();
    }

    private onClickUnlock(): void {

        GameVars.levelCompleted = null;
        GameManager.unlockAll();
        GameManager.enterLobbyScene();
    }

    private onClickLevelsEditor(): void {

        GameManager.enterLevelsEditorScene();
    }
}
